import { matchPath } from 'react-router-dom';

// ADR-0013
export const PUBLIC_RESPONDENT_ROUTES = {
  TAKE: '/surveys/:shareId/take',
  LINKEDIN_VERIFY: '/surveys/:shareId/linkedin',
  LINKEDIN_NOT_ELIGIBLE: '/linkedin/not-eligible',
  LINKEDIN_ERROR: '/linkedin/error',
  COMPLETE: '/survey-complete',
  COMPLETE_SESSION: '/survey-complete/:sessionId',
  PHOTO_UPLOAD: '/upload/:uploadToken',
} as const;

const PUBLIC_RESPONDENT_PATTERNS: readonly string[] = Object.values(PUBLIC_RESPONDENT_ROUTES);

export const isPublicRespondentPath = (pathname: string): boolean =>
  PUBLIC_RESPONDENT_PATTERNS.some((pattern) => matchPath(pattern, pathname) !== null);
